import React from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import { sanitizePathname } from './sanitizePathname';
import { parseQueryString, generateQueryString } from './queryString';

export const SanitizeUrl: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const pathname = sanitizePathname(location.pathname);
  const search = generateQueryString(parseQueryString(location.search));

  if (
    (pathname && location.pathname !== pathname) ||
    (location.search && location.search !== `?${search}`)
  )
    return <Redirect to={pathname + (search && `?${search}`) + location.hash} />;

  return <>{children}</>;
};
